import { render } from "./CategoriesList.vue?vue&type=template&id=7ad75bdb&scoped=true"
import script from "./CategoriesList.vue?vue&type=script&lang=js"
export * from "./CategoriesList.vue?vue&type=script&lang=js"

import "./CategoriesList.vue?vue&type=style&index=0&id=7ad75bdb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ad75bdb"

export default script